export const SearchSettings = Object.freeze({
  KeyTypeLabel: 'tl',
  KeyKeyword: 'keyword'
});
